import React from 'react';
import { IonSkeletonText } from '@ionic/react';

const LeagueSelectionSkeleton: React.FC = () => {
  return (
    <div className="flex-col justify-center pt-8 pb-8 space-y-[20px]">
      {[1, 2].map((item) => (
        <div key={item} className="flex items-center justify-between w-full">
          <div className="flex-col space-y-[2px] w-3/4">
            <div>
              <IonSkeletonText 
                animated 
                style={{ width: '70%', height: '16px' }} 
                className="rounded-md"
              />
            </div>
            <div>
              <IonSkeletonText 
                animated 
                style={{ width: '90%', height: '12px' }} 
                className="rounded-md"
              />
            </div>
          </div>
          <div className="h-full flex items-center justify-center">
            <IonSkeletonText 
              animated 
              style={{ width: '20px', height: '20px' }}
              className="rounded-full"
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default LeagueSelectionSkeleton;
